import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Bell } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "./ui/dropdown-menu";

const SEV = { danger: "bg-red-500", warning: "bg-amber-500", info: "bg-sky-500" };

export default function NotificationBell() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data = { count: 0, items: [] } } = useQuery({ queryKey: ["notifications"], queryFn: () => api.get("/notifications").then((r) => r.data) });

  const openNotif = async (n) => {
    qc.setQueryData(["notifications"], (d) => (d ? {
      count: Math.max(0, d.count - 1),
      items: d.items.filter((x) => x.key !== n.key),
    } : d));
    try { await api.post("/notifications/dismiss", { key: n.key }); } catch {}
    navigate(n.link);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="relative text-slate-300 hover:text-white" data-testid="notification-bell">
          <Bell className="h-5 w-5" />
          {data.count > 0 && (
            <span className="absolute -top-1.5 -right-1.5 h-4 min-w-[16px] px-1 rounded-full bg-red-500 text-[10px] font-bold text-white flex items-center justify-center">
              {data.count}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0">
        <div className="px-4 py-3 border-b border-slate-100 font-heading font-semibold text-slate-800 text-sm">
          Notifications {data.count > 0 && <span className="text-slate-400 font-normal">({data.count})</span>}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {data.items.length === 0 && <div className="px-4 py-8 text-center text-sm text-slate-400">You're all caught up.</div>}
          {data.items.map((n, i) => (
            <button key={n.key || i} onClick={() => openNotif(n)} data-testid={`notif-${i}`}
              className="w-full text-left px-4 py-3 hover:bg-slate-50 border-b border-slate-50 flex gap-3">
              <span className={`mt-1.5 h-2 w-2 rounded-full shrink-0 ${SEV[n.severity] || "bg-slate-400"}`} />
              <span>
                <span className="block text-sm font-medium text-slate-800">{n.title}</span>
                <span className="block text-xs text-slate-500">{n.message}</span>
              </span>
            </button>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
